// AppRouting.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import Articles from '../pages/Articles';
import Login from '../pages/Login';
import Shops from '../pages/Shops';
import Sale from '../pages/Sale'; 
import ProtectedRoute from './ProtectedRoute';
import ShopManagement from '../pages/ShopManagement';
import CommandeManagement from '../pages/CommandeManagement';
import ClientFournisseur from '../pages/ClientFournisseur';
import MouvementStock from '../pages/MouvementStock';
import OrderCard from '../pages/OrderCard'
import UserManagement from '../pages/UsersManagement'


import App from '../App';
import StockGeneral from '../pages/StockGeneral';

const AppRouting = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />  {/* Login page does not have the navbar */}
      <Route element={<App/>}>  
      <Route path="/App" element={<ProtectedRoute component={App} />} />
      <Route path="/dashboard" element={<ProtectedRoute component={Dashboard} permissionKey="canAccessDashboard" />} />
      <Route path="/articles" element={<ProtectedRoute component={Articles} permissionKey="canAccessArticles" />} />
      <Route path="/shops" element={<ProtectedRoute component={Shops} permissionKey="canAccessShop" />} />
      <Route path="/shopManagement" element={<ProtectedRoute component={ShopManagement} permissionKey="canAccessShopManagement" />} />
      <Route path="/Commande" element={<ProtectedRoute component={CommandeManagement} permissionKey="canAccessCommande" />} />
      <Route path="/clientFournisseur" element={<ProtectedRoute component={ClientFournisseur} permissionKey="canAccessClientFournisseur" />} />
      <Route path="/MouvementStock" element={<ProtectedRoute component={MouvementStock} permissionKey="canAccessMouvementStock" />} />
      <Route path="/MouvementStock/:article" element={<ProtectedRoute component={MouvementStock} permissionKey="canAccessMouvementStock" />} />
      <Route path="/orders" element={<ProtectedRoute component={OrderCard} permissionKey="canAccessOrders" />} />
      <Route path="/Users" element={<ProtectedRoute component={UserManagement} permissionKey="canAccessUsers" />} />
      <Route path="/StockGenerale" element={<ProtectedRoute component={StockGeneral} permissionKey="canAccessStockGenerale" />} />

      </Route>

      {/* All routes inside Layout will have the navbar */}
    </Routes>
  );
};

export default AppRouting;
